import MixCutPreviw from "@/stores/mixCutPreview";

interface IUseMixCutDetailPreviewReturn {
  data: any[];
  handlePreviewItemAdd: (data: any) => void;
  handlePreviewChange: (data: any[]) => void;
  handlePreviewClear: () => void;
}

const useMixCutDetailPreview = (): IUseMixCutDetailPreviewReturn => {
  const handlePreviewItemAdd = (item: any) => {
    console.log("item", item);
    const data = MixCutPreviw.getData();
    MixCutPreviw.setData([...data, item]);
  };

  const handlePreviewChange = (data: any[]) => {
    MixCutPreviw.setData(data);
  };

  const handlePreviewClear = () => {
    MixCutPreviw.setData([]);
  };

  return {
    data: MixCutPreviw.getData(),
    handlePreviewClear,
    handlePreviewChange,
    handlePreviewItemAdd,
  };
};

export default useMixCutDetailPreview;
